import { useQuery } from '@tanstack/react-query';
import type { BooksHealthResponse } from '@accounting/shared';
import { api } from '../lib/api';

export function booksHealthKey(ids: string[], asOf: string) {
  return ['books-health', [...ids].sort().join(','), asOf] as const;
}

/**
 * Cross-company books health. Not cached aggressively — the whole point is to
 * reflect the state of the books right now, so a stale green is worse than a
 * short wait.
 */
export function useBooksHealth(ids: string[], asOf: string) {
  return useQuery({
    queryKey: booksHealthKey(ids, asOf),
    enabled: ids.length > 0 && !!asOf,
    staleTime: 0,
    queryFn: () =>
      api.get<BooksHealthResponse>('/books-health', {
        companyIds: ids.join(','),
        asOf,
      }),
  });
}
